import {useState, useEffect} from "react";
import axios from "axios";
import {useLocation} from "react-router-dom";

import { useAuth } from "../hooks/useAuthProvide";



const REACT_APP_API_BASE_URL = (window._env_ && window._env_.API_URL) ? window._env_.API_URL + '/api/cc/' : process.env.REACT_APP_API_BASE_URL;

export default function useAuthenticatedRequest(options) {
  const [requestArgs, triggerRequest] = useState(options);
  const [state, setState] = useState({
    isLoading: !!options,
    data: null,
    error: null,
  });
  const {sessionToken, logout} = useAuth();
  const location = useLocation();

  useEffect(() => {
    async function request() {
      try {
        setState({
          isLoading: true,
          data: null,
          error: null,
        });
        // console.log(requestArgs)
        const {data} = await axios({
          ...requestArgs,
          url: `${REACT_APP_API_BASE_URL}${requestArgs.url}`,
          params: {
            ...requestArgs.params,
            ...(requestArgs.method !== "POST" && {sessionToken}),
          },
          ...(requestArgs.method === "POST" ? {
            data: {
              ...requestArgs.data,
              sessionToken,
            }
          } : {
            data: requestArgs.data, data2:requestArgs.data2
          }),
        });

        setState({
          isLoading: false,
          data: data.data,
          error: null,
        });
      } catch (error) {
        console.log(error);

        if (error.response) {
          if (error.response.status === 401) {
            console.log("Session expired logging out, returnsTo: ", location.pathname);
            logout({sessionExpired: true, returnsTo: location.pathname});
          } else {
            const {message} = error.response.data;
            setState({
              isLoading: false,
              data: null,
              error: message,
            });
          }
        } else {
          setState({
            isLoading: false,
            data: null,
            error: "Ops! Qualcosa è andato storto per favore controlla la tua connessione internet o riprova più tardi.",
          });
        }
      }

      triggerRequest(null);
    }
    
    // console.log(requestArgs?.data)
    
    if (requestArgs) {
      request();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestArgs, sessionToken]);

  return [
    state,
    triggerRequest,
  ];
}
